import React from "react";
import classNames from "classnames";
import styles from "./dotLoader.css";

export enum DotStyleType {
  WIDGET = "widget",
  DASHBOARD = "dashboard"
}

interface Props {
  dotType: DotStyleType;
  loadingText?: string;
}

export const DotLoader = ({ dotType, loadingText }: Props) => (
  <div className={styles.loader}>
    <div className={classNames(styles.container, styles[dotType])}>
      <div className={classNames(styles.dot, styles[dotType], styles.first)} />
      <div className={classNames(styles.dot, styles[dotType], styles.second)} />
      <div className={classNames(styles.dot, styles[dotType], styles.third)} />
    </div>
    {loadingText && <span className={styles.text}>{loadingText}</span>}
  </div>
);
